<template>
  <div id="page-user-list">
    <div class="vx-card p-6  minus-top">
      <div  class="vx-col md:w-1/2  w-full mb-4">
        <span  class="title-page ml-6">{{$t('adminFbIcon.title')}}</span>
      </div>
      <div class="flex flex-wrap items-center ml-4">
          <div class="vx-row ml-2 ">
               <vs-button
              color ="primary"
              type ="border"
              @click="addFacebook"
              class="text-size"
              >
                 {{$t('adminFbIcon.addFb')}}
              </vs-button>
            <vs-button class="ml-2 text-size" @click="exportFileCSV" color ="success" type ="border">{{$t('adminFbIcon.formCSV')}}</vs-button>
            <vs-button class="ml-2 text-size" @click="importFile" color ="warning" type ="border">{{$t('adminFbIcon.importCSV')}}</vs-button>
          </div>
          <div class ="flex-grow">
          </div>
          <vs-input
          class="text-size sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          :placeholder ="this.$t('adminFbIcon.search')"
          v-model="searchData.searchQuery"
          v-on:keydown.enter="searchFacebook"
          style="max-width: 200px;"
           />
      </div>
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        style="height:55vh"
        ref="agGridTable"
        :components ="components"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef = "defaultColDef"
        :rowData = "rowDatas"
        :animateRows = "true"
        :pagination = "true"
        :paginationPageSize ="20"
        :onGridReady ="onGridReady"
        :suppressPaginationPanel = "true"
        :per-page="0"
      >
      </ag-grid-vue>
      <vs-pagination
      :total ="totalPages"
      :max="maxPageNumbers"
      v-model="currentPage"
      :per-page="perPage"
      @change="onChangePage"
      ></vs-pagination>
  </div>

  <vs-popup title="Import file CSV" :active.sync="activeFile">
    <div class="vx-row">
      <div style="margin:auto">
    <div class="mb-8">
      <import-excel :onSuccess="loadDataInTable" />
        </div>
        <vx-card v-if="tableData.length && header.length">
          <vs-table stripe pagination :max-items="10" search :data="tableData" :noDataText="this.$t('noData')">
            <template slot="header">
              <h4>{{ sheetName }}</h4>
            </template>

            <template slot="thead">
              <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
                  {{ col }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
      <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="border-radius ml-auto mt-2 text-size" icon="icon-plus" icon-pack="feather" @click="saveDataImport">{{$t('adminFbIcon.saveData')}}
                </vs-button>
                <vs-button class="border-radius ml-4 mt-2 text-size" type="border" icon="icon-X" icon-pack="feather" @click="closePopup">{{$t('adminFbIcon.closePopup')}}
                </vs-button>
              </div>
            </div>
          </div>
  </vs-popup>
  </div>
</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererRelationship from "./cell-renderer/CellRendererRelationship.vue"
import CellRendererGender from "./cell-renderer/CellRendererGender.vue"
import CellRendererIsPrivate from "./cell-renderer/CellRendererIsPrivate.vue"
import CellRendererType from "./cell-renderer/CellRendererType.vue"
import {AgGridVue} from "ag-grid-vue"
import moment from "moment";

import ImportExcel from "@/components/excel/ImportExcel.vue"
export default {
    components :{
      AgGridVue,
      CellRendererStatus,
      CellRendererActions,
      CellRendererRelationship,
      CellRendererGender,
      CellRendererIsPrivate,
      CellRendererType,
      ImportExcel
    },
    data(){
      return {
        tableData: [],
        header: [],
        sheetName: "",
        file:null,
        activeFile:false,
        check: 0,
        maxPageNumbers:6,
        gridApi:null,
        perPage:10,
        totalPages:0,
        gridOptions:{},
        defaultColDef:{},
        gripApi:null,
        optionalType:[
          {text:'Trang cá nhân',value:'profile'},
          {text:'Trang Facebook',value:'page'},
          {text:'Nhóm Facebook',value:'group'}
        ],
        columnDefs:[
          {
            headerName:'ID',
            field:'id',
            width:70
          },
          {
            headerName:this.$t('adminFbIcon.nameFb'),
            field:'detailName',
            width:70,
            cellRenderer: function(params) {
              return `<a href="${params.data.link}" target="_blank" rel="noopener">${params.value || params.data.link}</a>`
            }
          },
          // {
          //   headerName: 'Url',
          //   field:'link',
          //   width:150,

          // },
          // {
          //   headerName:'Địa chỉ',
          //   field:'address',
          //   width:200,
          // },
          {
            headerName:this.$t('adminFbIcon.type'),
            field:'type',
            width:30,
            cellRendererFramework:'CellRendererType'
          },
          // {
          //   headerName:'Ngày tạo',
          //   field:'createDate',
          //   width:150
          // },
          {
            headerName:this.$t('adminFbIcon.action'),
            field:'transactions',
            width:30,
            cellRendererFramework:'CellRendererActions'
          }
        ],
        rowDatas:[],
      searchData:{
        searchQuery: ""
      },
      components:{
        CellRendererActions,
        CellRendererStatus,
        CellRendererGender,
        CellRendererRelationship,
        CellRendererIsPrivate,
        CellRendererType
      },
      dataPagination:[],
      pageNumbers:null,
      pageSize:null,
      currentPage:1,
      dataFile:[],

      form :
        {
          uid:null,
          type:null,
          status:null,
          private:null,
          priority:null,
          optionalStatus: null,
          link:null,
          details: {
            name:null,
            gender:null,
            location:null,
            }
        }
      }
    },
    created(){
      this.initScreen();
      this.$eventBus.$on('i18n', () =>{
        this.columnDefs[1].headerName =  this.$t('adminFbIcon.nameFb');
        this.columnDefs[2].headerName =  this.$t('adminFbIcon.type');
        this.columnDefs[3].headerName =  this.$t('adminFbIcon.action');
        this.gridOptions.api.setColumnDefs(this.columnDefs);

      })
    },
    computed:{

    },
    watch:{
       '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdateUser'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      },
    },
    methods:{
      saveDataImport: function(){
        const result = this.tableData;
        const payload = [];
        for(let c = 0; c < result.length; c++){
          if (isNaN(result[c][2].trim()) || ![1, 2, 3].includes(parseInt(result[c][2].trim()))){
            return this.$vs.notify({
              text:this.$t('adminFbIcon.text3'),
              icon:'icon-alert',
              iconPack:'feather',
              color:'danger'
            })
          }
          let item = {
            link: result[c][1].trim(),
            type: this.optionalType[result[c][2].trim() - 1].value,
          }
          payload.push(item)
        }
        this.$processor.post(`facebook-queue/create/list`, payload).then(() =>{
          this.activeFile = false;
          this.dataFile = [];
          this.tableData = [];
          this.getListFacebook();
          this.$vs.loading.close();
          return this.$vs.notify({
            text:this.$t('adminFbIcon.text4'),
            icon:'icon-alert',
            iconPack:'feather',
            color:'primary'
          })
        }).
        catch((err) =>{
          this.$vs.loading.close();
          return this.$vs.notify({
               text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
      },
      exportFileCSV: function(){
        const rows = [
            ["STT" , "Link Facebook",  "Type  ( 1 - Personal / 2 - Page / 3 - Group )" ]
        ];
        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function(rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
        });

        let data = encodeURI(csvContent);

        const filename = 'template-import-facebook.csv';
        const link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        link.click();
      },
      loadDataInTable({ results, header, meta }) {
        this.header = header
        this.tableData = results
        this.sheetName = meta.sheetName
      },
      removeElementsByClass(classname){
        let elements = document.getElementsByClassName(classname);
        while(elements.length > 0){
          elements[0].parentNode.removeChild(elements[0]);
        }
      },
      closePopup: function(){
        this.activeFile = false;
        this.dataFile = [];
        this.tableData = [];
      },
      importFile:function(){
        this.activeFile = true;
        this.file = null;
      },
      onFileChange(){
        const readFile = document.getElementById('csv')
        const file = readFile.files[0];
        const reader = new FileReader();
        reader.readAsBinaryString(file)
      },
      onChangePage(event){
        this.$vs.loading();
        const page = String(event);
         let conditions = {
            pageNumber:parseInt(page) - 1,
            pageSize:20,
            searchQuery: this.searchData.searchQuery,
          };
        this.$processor.post('/facebook-queue/range',conditions).then((response) =>{
           response.data.content.forEach(x => {
             let detail = {};
             try {
              detail = JSON.parse(x.details);
              if (detail) {
                x.detailName = detail.name;
                x.createDate = moment(x.createDate).format('DD-MM-YYYY');
                if(detail.location){
                  x.address = detail.location.name;
                }
              }
             } catch (e) {
               console.log(e)
             }
            })
            this.rowDatas = response.data.content;
            this.totalPages = parseInt(response.data.totalPages,10);
            this.pageNumbers = response.data.pageable.pageNumber;
            this.$vs.loading.close();
          }).catch(()=>{
            this.$vs.loading.close();
          })

      },
      onGridReady(){
        if(this.$store.state.windowWidth <= 1024){
          this.maxPageNumbers = 5;
        }
        else{
          this.maxPageNumbers = 7;
        }
        if(this.$store.state.windowWidth > 1024){
          this.gridApi.sizeColumnsToFit();
        }
      },
      async initScreen(){
        this.getListFacebook();
      },
      addFacebook(){
        this.$router.push('/page/facebook/add').catch(() =>{});
      },
      searchFacebook(){
          this.getListFacebook()
      },
      getListFacebook(){
        this.$vs.loading();
         let conditions = {
            pageNumber:0,
            pageSize:20,
            searchQuery: this.searchData.searchQuery,
          };
        this.$processor.post('/facebook-queue/range',conditions).then((response) =>{
           response.data.content.forEach(x => {
              let detail = {};
              try {
                detail = JSON.parse(x.details);
                if (detail) {
                  x.detailName = detail.name;
                  x.createDate = moment(x.createDate).format('DD-MM-YYYY');
                  if(detail.location){
                    x.address = detail.location.name;
                  }
                }
              } catch (e) {
                console.log(e)
              }
            })
            this.rowDatas = response.data.content;
            this.totalPages = parseInt(response.data.totalPages,10);
            this.pageNumbers = response.data.pageable.pageNumber;
            this.$vs.loading.close();
          }).catch(()=>{})

      }
    },
    mounted(){
      this.gridApi = this.gridOptions.api;
      if(document.getElementsByClassName('ag-body-horizontal-scroll-viewport')[0]){
        document.getElementsByClassName('ag-body-horizontal-scroll-viewport')[0].style.maxWidth = '0px'
      }
    }

}
</script>
<style lang="postcss" scoped>
.ag-theme-material w-100 my-4 ag-grid-table{
  cursor: pointer;
}
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.minus-top{
  margin-top: -24px;
}
</style>
